var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fill-height"},[_c('div',{staticClass:"full-width-div fill-height"},[(
        _vm.$router.currentRoute.name != 'office' &&
        _vm.$router.currentRoute.name != 'reports'
      )?_c('Toolbar'):_vm._e(),_c('v-divider'),_c('v-scroll-x-transition',{attrs:{"mode":"out-in","hide-on-leave":""}},[_c('router-view')],1)],1),_c('FileDetails')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }